<script lang="ts">import { cfgMicrosoftClarityId } from "@infinitro/config";
const clarityId = cfgMicrosoftClarityId();
</script>

<svelte:head>
	{#if clarityId}
		<script async src={`https://www.clarity.ms/tag/${clarityId}`}></script>
	{/if}
</svelte:head>
